import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { archivedWorkItemsJwmRoute } from '@jira/router-routes__archives-routes/src/archivedWorkItemsJwmRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { archivedIssuesPageEntryPoint, getCommonProjectLayout } from './ui/index.tsx';

export const archivedWorkItemsJwmRouteEntry: Route = createEntry(archivedWorkItemsJwmRoute, () => ({
	group: 'archived-work-items',

	// Refer: issueNavigatorProjectBusinessRoute from issue-navigator
	layout: getCommonProjectLayout(),

	entryPoint: () => archivedIssuesPageEntryPoint,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...getBusinessProjectResources(),
	],

	supportsPreviewPanel: true,
	supportsProjectTheme: 'contoured',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
